import Data from "../data/Data";
export default class MainCardUtils {
    static getEditInfoInputs = () => {
        return [
            {
                inputLabel: "Título*",
                inputPlaceholder: "Título",
                name: "title",
                text: Data.getAdviceTextFromInputs().title,
                description: "Título que irá aparecer no Header do eitri-app."
            },
            {
                inputLabel: "Identificador*",
                inputPlaceholder: "com.company.domain",
                name: "slug",
                text: Data.getAdviceTextFromInputs().slug,
                description:
                    "Identificador que diferencia dos outros eitri-apps."
            },
            // {
            //     inputLabel: "Parent slug",
            //     inputPlaceholder: "com.company.domain",
            //     name: "parentSlug",
            //     text: Data.getAdviceTextFromInputs().slug, // mesmo advice de slug
            //     description: "Eitri-App pai onde se abre os detalhes do pedido."
            // },
            {
                inputLabel: "Chave pública*",
                inputPlaceholder: "chave id identificadora",
                name: "walletToken",
                text: Data.getAdviceTextFromInputs().walletToken,
                description: "Identificador do beneficiário."
            }
        ];
    };

    static getRegisterInfoInputs = () => {
        return [
            {
                inputLabel: "Título*",
                inputPlaceholder: "Título",
                name: "title",
                text: Data.getAdviceTextFromInputs().title,
                description: "Título que irá aparecer no Header do eitri-app."
            },
            {
                inputLabel: "Identificador*",
                inputPlaceholder: "com.company.domain",
                name: "slug",
                text: Data.getAdviceTextFromInputs().slug,
                description:
                    "Identificador que diferencia dos outros eitri-apps."
            }
        ];
    };
}
